export default "__VITE_ASSET__sB6jdTBc__"